import { useEffect } from 'react';
import MetaData from '../../layouts/MetaData';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import  'react-multiple-select-dropdown-lite/dist/index.css';
import { useDispatch, useSelector } from 'react-redux';
import { addDoctor } from '../../actions/adminActions';
import { useAlert } from 'react-alert';
import TextField from '../../components/Form/TextField';
import GenderSelectbox from '../../components/Form/GenderSelectbox';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import {HIDE_ALERT_MESSAGE} from '../../constants/Common';



const AddNewDoctor = () => { 

    const dispatch = useDispatch();
    const alert = useAlert();
    const history = useHistory();


    const {message, error } = useSelector(state => state.common);

    const validate = Yup.object().shape({
		firstname: Yup.string()
        .required('First Name is required')
        .min(2, 'Should be atleast 2 characters')
        .max(20, 'Should be less than 20 characters'),
		lastname: Yup.string() 
		  .min(2, 'Should be atleast 2 characters')
		  .max(20, 'Should be less than 20 characters')
		  .required('Last Name is Required'),
        email: Yup.string().email('Invalid email').required('Email is required'),  
		password: Yup.string()
        .min(6, 'Minimum 6 characters')
        .max(20, 'Maximum 20 characters')
        .required('Password is Required'),
        DOB:Yup.string().required('DOB is required'),
        mobileNo: Yup.string(),
        phone1: Yup.string().required('Primary Phone is required')
        .min(6, 'minimum 6 characters allowed')
        .max(12, 'maximum 12 characters allowed'),
        gender: Yup.string().required('Gender is required'),
        npinumber: Yup.string().required('NPI number is required')
        .min(6, 'Minimum 6 characters')
        .max(12, 'Maximum 12 characters allowed'),
        licensenumber: Yup.number(),
        specialization: Yup.string().required('Specialization is required')
	  });


    useEffect(() => {
        if(error){
            alert.error(error);

            dispatch({
                type: HIDE_ALERT_MESSAGE
            })
            
        }

    if(message){
        alert.success(message);
        history.push('/doctors');

        dispatch({
            type: HIDE_ALERT_MESSAGE
        })
    }

}, [dispatch, alert, error, message, history]);

    const submitHandler = (values) => {
		dispatch(addDoctor(values));
    }

    return (
        <>
            <MetaData title="Add New Provider"/>
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />


                <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded">
                    <div className="home-content">
                        <div className="row-display">
                            
                        <h5 style={{color: '#004aad'}}>
                            <i className="bx bx-user"></i> <strong>&nbsp;Add New Provider </strong>
                        </h5>

                            <div className="row-display">
                                    <button className="btn btn-secondary btn-sm" onClick={() => history.goBack()}>
                                        <i className='bx bx-arrow-back'></i>
                                    </button>
                                &nbsp;&nbsp;
                                <Link to="/adminDashboard">
                                    <button className="btn btn-secondary btn-sm">
                                        <i className='bx bxs-home'></i>
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <hr />

                        <Formik initialValues={{ 
                            firstname: '',
                            lastname: '',
                            email: '',
                            gender:'',
                            password:'',
                            DOB: '',
                            phone1:'',
                            npinumber: '',
                            specialization:'',
                            practice:''
                        }}
                         validationSchema={validate}
                         onSubmit={values => {
                            submitHandler(values)
                        }}
                         >   
                         { formik => (
                             <div>
                             <Form>
                                 <div className="row">
                                     {/* First Name */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="First Name" 
                                             name="firstname" 
                                             type="text" 
                                             placeholder="First Name"
                                         />
                                     </div>

                                     {/* Last Name */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="Last Name" 
                                             name="lastname" 
                                             type="text" 
                                             placeholder="Last Name"
                                         />
                                     </div>

                                     {/* Gender */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <GenderSelectbox 
                                        label="Gender"
                                        name="gender"
                                    />
                                    </div>

                                     {/* DOB */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <TextField 
                                            label="DOB" 
                                            name="DOB" 
                                            type="date" 
                                        />
                                    </div>

                                     {/* Email */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="Email" 
                                             name="email" 
                                             type="email" 
                                             placeholder="Email Address"
                                         />
                                     </div>

                                     {/* Password */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="Password" 
                                             name="password" 
                                             type="text" 
                                             placeholder="Password"
                                         />
                                     </div>

                                     {/* Phone1 */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="Primary Phone" 
                                             name="phone1" 
                                             type="text" 
                                             placeholder="Phone 1"
                                         />
                                     </div>

                                     {/* Mobile Number */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="Mobile Number" 
                                             name="mobileNo" 
                                             type="text" 
                                             placeholder="Mobile Number"
                                         />
                                     </div>

                                    {/* NPI Number */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <TextField 
                                            label="NPI Number" 
                                            name="npinumber" 
                                            type="text"
                                            placeholder="NPI Number" 
                                        />
                                    </div>

                                     {/* license Number */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="license Number" 
                                             name="licensenumber" 
                                             type="text" 
                                             placeholder="License Number"
                                         />
                                     </div>

                                     {/* license Number */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="Specialization" 
                                             name="specialization" 
                                             type="text" 
                                             placeholder="Provider Specialization"
                                         />
                                     </div>

                                     {/* Practice / Organization */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <TextField 
                                             label="Practice / Organization" 
                                             name="practice" 
                                             type="text" 
                                             placeholder="Practice or organization name"
                                         />
                                     </div>


                                    </div> {/* row ends here */}

                                    {/* Buttons */}
                                    <div className="row mr-3" style={{ float: 'right'}}>
                                        <button className="btn btn-outline-danger btn-sm" type="reset">Reset</button> &nbsp;&nbsp;
                                        <button className="btn btn-outline-primary btn-sm" type="submit">Add Provider</button>
                                    </div>

                                    <br/><br/>
                            </Form>
                        </div>   
                        )}
                        </Formik>

                        </div>
                    </div>
                </section>
        </>
    )
}

export default AddNewDoctor
